import SyncIcon from '@mui/icons-material/Sync';
import { Button, useNotify, useRefresh, useUpdateMany } from 'react-admin';
import { DataProviderResource } from 'src/constants';

interface SyncAccountListStatusButtonProps {
  ids: string[];
}

export const SyncAccountListStatusButton = ({ ids }: SyncAccountListStatusButtonProps) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const [updateMany, { isLoading }] = useUpdateMany();

  const onSyncAccountsStatus = async () => {
    updateMany(
      DataProviderResource.AccountSyncStatusList,
      {
        ids,
      },
      {
        onSuccess: () => {
          notify('Account/s status synchronization request was successfully submitted.', { type: 'success' });
        },
        onSettled: () => {
          refresh();
        },
        onError: err => {
          notify(`Account/s status synchronization request error: ${err}`, {
            type: 'error',
          });
        },
      },
    );
  };

  return (
    <Button label={'Status'} onClick={onSyncAccountsStatus} disabled={isLoading} style={{ marginTop: '8px' }}>
      <SyncIcon />
    </Button>
  );
};
